import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AddEvent from "./AddEvent";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
function EventInfo({ event, isCreating, cleanEvent }) {
  const [addClicked, setAddClicked] = useState(!!event);
  const [selectedEvent, setSelectedEvent] = useState(event ? event.id : null);
  const [resetKey, setResetKey] = useState(0);

  useEffect(() => {
    if (isCreating) {
      handleAddClick();
    }

    if (event) {
      setSelectedEvent(event.id);
      setAddClicked(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreating, event]);

  const handleAddClick = () => {
    setAddClicked(true);
  };

  const handlePlusClick = () => {
    setAddClicked(true);
    setSelectedEvent(null);
    setResetKey((prev) => prev + 1);
    cleanEvent();
  };
  return (
    <div className="p-4 bg-white rounded-lg shadow-lg h-full">
      <div className="flex justify-between items-center mb-4">
        <h1 className="uppercase text-xl">Event Info</h1>
        <FontAwesomeIcon
          icon={faPlus}
          size="sm"
          className="bg-[#5057FF] text-white p-2 rounded cursor-pointer"
          onClick={handlePlusClick}
        />
      </div>
      <AddEvent
        addClicked={addClicked}
        event={event}
        selectedEvent={selectedEvent}
        setSelectedEvent={setSelectedEvent}
        resetKey={resetKey}
      />
    </div>
  );
}
export default EventInfo;
